import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, isRef as _isRef } from "vue"

const _hoisted_1 = {
  class: "im-chat-main",
  style: {"background-color":"#f8f8f8"}
}
const _hoisted_2 = {
  class: "messages",
  id: "his-chat-message",
  style: {"height":"100%"}
}
const _hoisted_3 = {
  class: "im-chat-user",
  id: "historyMessageBox"
}
const _hoisted_4 = {
  key: 0,
  class: "message-info right"
}
const _hoisted_5 = {
  key: 1,
  class: "message-info"
}
const _hoisted_6 = {
  key: 0,
  class: "im-chat-text"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  class: "im-chat-text",
  style: {"width":"50%"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "im-chat-text",
  style: {"width":"50%"}
}
const _hoisted_11 = ["title", "href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "file-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-xiazai" })
], -1)
const _hoisted_13 = { class: "file-text" }
const _hoisted_14 = { class: "file-name" }
const _hoisted_15 = ["onClick"]

import {
  getCurrentInstance,
  nextTick,
  reactive,
  ref,
  toRefs,
  watch,
} from "vue";
import MessageApi from "@/api/MessageApi";
import Avatar from "@/components/Avatar.vue";
import Time from "@/components/Time.vue";
import ChatUtils from "@/utils/ChatUtils";
import MessageType from "@/utils/MessageType";
import { useUserStore } from "@/store/userStore.ts";
import Message from "@/mode/Message";


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryMessage',
  props: {
  chatUsers: {
    type: Map,
    required: true,
    default: {},
  },
  chatId: {
    type: String,
    required: true,
    default: "",
  },
  fromId: {
    type: String,
    required: true,
    default: "",
  },
  type: {
    type: String,
    required: true,
    default: "",
  },
  showHistory: {
    type: Boolean,
    required: true,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const userStore = useUserStore();
const { proxy } = getCurrentInstance();
const size = ref(10);
const currentUser = userStore.getUser();


const data = reactive({
  hisMessageList: [],
  current: 1,
  total: 0,
});

// 附件和图片点击展开
const openImageProxy = (event: any) => {
  event.preventDefault();
  if (event.target.nodeName === "IMG") {
    proxy.$winControl.default.openURL(event.target.src);
  } else if (
    event.target.className === "message-file" ||
    event.target.nodeName === "A"
  ) {
    proxy.$winControl.default.openURL(event.target.href);
  }
};

//语音
const Audio = ref();
//控制播放还是暂停音频文件
const handleAudio = (item: Message) => {
  if (Audio.value.paused) {
    Audio.value.src = item.extend.url;
    Audio.value.play();
  } else {
    Audio.value.src = "";
    Audio.value.stop();
  }
};
const change = (current: number) => {
  MessageApi.page(
    props.chatId,
    props.fromId,
    props.type,
    "",
    current,
    size.value
  ).then((res) => {
    data.hisMessageList = res.data.records.reverse();
    console.log(res.data.records);
    data.total = res.data.total;
    data.current = current;
    nextTick(() => {
      ChatUtils.imageLoad("his-chat-message");
    });
  });
};

watch(
  () => {
    return props.showHistory;
  },
  (n) => {
    if (n) {
      change(1);
    }
  },
  {
    immediate: true,
  }
);
const { hisMessageList, current, total } = toRefs(data);

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hisMessageList), (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass({ 'im-chat-mine': item.fromId === _unref(currentUser).id })
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(Avatar, {
                  img: __props.chatUsers.get(item.fromId)?.avatar,
                  name: __props.chatUsers.get(item.fromId)?.name
                }, null, 8, ["img", "name"]),
                (item.fromId === _unref(currentUser).id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("i", null, [
                        _createVNode(Time, {
                          time: item.timestamp
                        }, null, 8, ["time"])
                      ]),
                      _createElementVNode("span", null, _toDisplayString(__props.chatUsers.get(item.fromId)?.name), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.fromId !== _unref(currentUser).id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(__props.chatUsers.get(item.fromId)?.name), 1),
                      _createElementVNode("i", null, [
                        _createVNode(Time, {
                          time: item.timestamp
                        }, null, 8, ["time"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (item.messageType === _unref(MessageType).text)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("pre", {
                      innerHTML: _unref(ChatUtils).transform(item.content)
                    }, null, 8, _hoisted_7)
                  ]))
                : _createCommentVNode("", true),
              (item.messageType === _unref(MessageType).image)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: item.extend.url,
                      style: {"width":"100%"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (openImageProxy($event)))
                    }, null, 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true),
              (item.messageType === _unref(MessageType).file)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("a", {
                      class: "file-box",
                      title: item.extend.fileName,
                      href: item.extend.url,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (openImageProxy($event)))
                    }, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(item.extend.fileName), 1)
                      ])
                    ], 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true),
              (item.messageType === _unref(MessageType).voice)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "im-chat-text",
                    style: _normalizeStyle({width: item.extend.time>40?'50%':(item.extend.time+10) + '%'})
                  }, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (handleAudio(item))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["iconfont icon-v-voice", {'icon-v-voice-right':item.mine}])
                      }, null, 2)
                    ], 8, _hoisted_15)
                  ], 4))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      currentPage: _unref(current),
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(current) ? (current).value = $event : null)),
      "page-size": size.value,
      layout: "prev, pager, next",
      total: _unref(total),
      onCurrentChange: change
    }, null, 8, ["currentPage", "page-size", "total"])
  ], 64))
}
}

})